<template>
  <InfuseSlideInLayout :title="user?.name" :parent-to="{ name: 'users' }">
    <template #header>
      <h1 class="text-xl font-bold text-neutral-700">
        <span>{{ user?.name }}</span>
      </h1>
    </template>

    <InfuseRouterTabLayout v-if="user" :model="user" @reload-model="refresh" />
    <InfuseSpinner v-else class="flex items-center justify-center p-16" size="medium" />
  </InfuseSlideInLayout>
</template>

<script setup lang="ts">
import { InfuseRouterTabLayout, InfuseSlideInLayout } from '@infuse/ui/layouts';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useRedirectOnNotFound } from '@infuse/e-connector/shared/composables';
import { useUser } from '@infuse/e-connector/user/queries';
import { InfuseSpinner } from '@infuse/ui/components';

const route = useRoute();
const id = computed(() => route.params.id?.toString());

const { user, fetchUserId, isError, error } = useUser();
useRedirectOnNotFound(isError, error);

watch(id, () => (fetchUserId.value = id.value), { immediate: true });

async function refresh() {
  fetchUserId.value = id.value;
}
</script>
